import React, { useState, useEffect } from 'react';

const EditAliasDialog = ({ show, alias, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    replacementValue: ''
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  // Initialize form data when alias changes
  useEffect(() => {
    if (alias) {
      setFormData({
        replacementValue: alias.replacementValue || ''
      });
      setErrors({});
    }
  }, [alias]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.replacementValue.trim()) {
      newErrors.replacementValue = 'Replacement value is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setSaving(true);
      await onSave(alias.id, {
        replacementValue: formData.replacementValue.trim()
      });
    } catch (err) {
      console.error('Error updating alias:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (alias) {
      setFormData({
        replacementValue: alias.replacementValue || ''
      });
    }
    setErrors({});
    onCancel();
  };

  if (!show || !alias) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Alias</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={handleCancel}
                disabled={saving}
              ></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Field Key
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={alias.fieldKey}
                    disabled
                    readOnly
                  />
                  <div className="form-text">
                    Field key cannot be changed
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Original Value
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={alias.originalValue}
                    disabled
                    readOnly
                  />
                  <div className="form-text">
                    Original value cannot be changed
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="replacementValue" className="form-label">
                    Replacement Value <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="replacementValue"
                    name="replacementValue"
                    className={`form-control ${errors.replacementValue ? 'is-invalid' : ''}`}
                    value={formData.replacementValue}
                    onChange={handleChange}
                    placeholder="Enter the standardized replacement value"
                    disabled={saving}
                  />
                  {errors.replacementValue && (
                    <div className="invalid-feedback">{errors.replacementValue}</div>
                  )}
                  <div className="form-text">
                    The standardized value that should replace the original value
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={handleCancel}
                  disabled={saving}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? 'Updating...' : 'Update Alias'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default EditAliasDialog;